var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "text-xs-center", attrs: { xs12: "", "mt-5": "" } },
            [
              _c("h1", { staticClass: "mb-4" }, [_vm._v("Sign Up")]),
              _vm._v(" "),
              _c("div", {
                staticStyle: {
                  width: "100%",
                  height: "20px",
                  "border-bottom": "1px solid black",
                  "text-align": "center"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", "offset-sm3": "", "mt-3": "" } },
            [
              _vm.signUpStep1
                ? _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.userSignUpStep1.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("v-flex", [
                        _c("h4", { staticClass: "my-4" }, [
                          _vm._v("Add Profile")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c("v-flex", [
                            _vm.error || _vm.errorMessage
                              ? _c(
                                  "div",
                                  { staticClass: "alert alert-danger" },
                                  [
                                    _vm.error
                                      ? _c("p", [
                                          _vm._v(" " + _vm._s(_vm.error) + " ")
                                        ])
                                      : _vm.errorMessage
                                      ? _c("p", [
                                          _vm._v(_vm._s(_vm.errorMessage) + " ")
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c("v-flex", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    staticStyle: { width: "48%", float: "left" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "exampleFormControlInput1"
                                        }
                                      },
                                      [_vm._v("First Name")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.firstName,
                                          expression: "firstName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder: "First Name",
                                        name: "firstName",
                                        required: ""
                                      },
                                      domProps: { value: _vm.firstName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.firstName = $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    staticStyle: {
                                      width: "50%",
                                      float: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "exampleFormControlInput1"
                                        }
                                      },
                                      [_vm._v("Last Name")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.lastName,
                                          expression: "lastName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Last Name",
                                        name: "lastName",
                                        required: ""
                                      },
                                      domProps: { value: _vm.lastName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.lastName = $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c("v-flex", [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "exampleFormControlInput1" }
                                    },
                                    [_vm._v("Email Address")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.email,
                                        expression: "email"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "email",
                                      placeholder: "Email Address",
                                      name: "email",
                                      required: ""
                                    },
                                    domProps: { value: _vm.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.email = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c("v-flex", [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "exampleFormControlInput1" }
                                    },
                                    [_vm._v("Password")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "password",
                                      placeholder: "Password",
                                      name: "password",
                                      required: ""
                                    },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c("v-flex", [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "exampleFormControlInput1" }
                                    },
                                    [_vm._v("Confirm Password")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.passwordConfirm,
                                        expression: "passwordConfirm"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "password",
                                      placeholder: "Confirm Password",
                                      name: "passwordConfirm",
                                      required: ""
                                    },
                                    domProps: { value: _vm.passwordConfirm },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.passwordConfirm =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { "mt-5": "" }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary",
                                      attrs: {
                                        type: "button",
                                        target: "_blank"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toRoute("signin")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Return to Sign In\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { type: "submit" }
                                    },
                                    [_vm._v("Next")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sentVerificationEmail
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { "mt-5": "" }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary",
                                      attrs: {
                                        type: "button",
                                        target: "_blank"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toRoute("signin")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Return to Sign In\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center ",
                              attrs: { "mt-4": "" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "google-btn",
                                  attrs: { type: "button" },
                                  on: { click: _vm.googleSignIn }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "google-icon-wrapper" },
                                    [
                                      _c("img", {
                                        staticClass: "google-icon",
                                        attrs: {
                                          src:
                                            "https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "btn-text" }, [
                                    _c("b", [_vm._v("Sign in with google")])
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.signUpStep2
                ? _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.userSignUpStep2.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          !_vm.sentVerificationEmail
                            ? _c("v-flex", [
                                _c("h4", { staticClass: "my-4" }, [
                                  _vm._v("Add Company Profile")
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-flex", [
                            _vm.errorMessage
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "alert alert-danger",
                                    attrs: { role: "alert" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.errorMessage) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c("v-flex", [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "exampleFormControlFile1" }
                                    },
                                    [_vm._v("Choose file")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "form-control-file",
                                    attrs: {
                                      type: "file",
                                      id: "exampleFormControlFile1",
                                      accept: ".jpg, .jpeg, .png",
                                      required: ""
                                    },
                                    on: { change: _vm.onFileChanged }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c("v-flex", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    staticStyle: { width: "48%", float: "left" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "exampleFormControlInput1"
                                        }
                                      },
                                      [_vm._v("Profession/ Job Title")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.profession,
                                          expression: "profession"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Profession/ Job Title",
                                        name: "profession",
                                        required: ""
                                      },
                                      domProps: { value: _vm.profession },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.profession = $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-group",
                                    staticStyle: {
                                      width: "50%",
                                      float: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "exampleFormControlInput1"
                                        }
                                      },
                                      [_vm._v("Organization Name")]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.organizationName,
                                          expression: "organizationName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Organization Name",
                                        name: "organizationName",
                                        required: ""
                                      },
                                      domProps: { value: _vm.organizationName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.organizationName =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail && !_vm.otherSwitch
                            ? _c("v-flex", [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "exampleFormControlInput1" }
                                    },
                                    [_vm._v("Organization Type")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedOrganizationType,
                                          expression: "selectedOrganizationType"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        name: "selectedOrganizationType",
                                        required: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.selectedOrganizationType = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value:
                                              "Please Select Organization Type",
                                            selected: "",
                                            disabled: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Please Select Organization Type\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: {
                                            value: "Educational Institution"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Educational Institution\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Studio" } },
                                        [_vm._v("Studio")]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail && _vm.otherSwitch
                            ? _c("v-flex", [
                                _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "exampleFormControlInput1" }
                                    },
                                    [_vm._v("Organization Type")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedOrganizationType,
                                        expression: "selectedOrganizationType"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Organization Type",
                                      name: "selectedOrganizationType",
                                      required: ""
                                    },
                                    domProps: {
                                      value: _vm.selectedOrganizationType
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.selectedOrganizationType =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sentVerificationEmail
                            ? _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "justify-center": "" } },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "\n                  We sent a verification link to your email address: " +
                                            _vm._s(_vm.email) +
                                            "\n                "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c(
                                "v-flex",
                                [
                                  _c("v-switch", {
                                    attrs: { label: "Other" },
                                    on: {
                                      change: function($event) {
                                        return _vm.toggleSwitch()
                                      }
                                    },
                                    model: {
                                      value: _vm.otherSwitch,
                                      callback: function($$v) {
                                        _vm.otherSwitch = $$v
                                      },
                                      expression: "otherSwitch"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.sentVerificationEmail
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { "mt-5": "" }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toRoute("signin")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Return to Sign In\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.goPrevious()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Previous\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: { type: "submit" }
                                    },
                                    [_vm._v("Sign Up")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sentVerificationEmail
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { "mt-5": "" }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toRoute("signin")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Return to Sign In\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-024d905c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024d905c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Signup.vue
// module id = null
// module chunks = 